const GUIDANCE_MESSAGES = {
  PRORATA_AUTH_CAPTURE_MSG: "We'll check your details and collect payment within the next 5 days.",
  HEADING: 'Complete the following instructions from your card provider below.',
  WARNING_APP: 'Please do not navigate away from this screen.',
  WARNING_WEB: 'Please do not refresh this page or use the back button.',
};

export default GUIDANCE_MESSAGES;
